<h5>{{ title }}</h5>
<ul *ngIf="type === 'enum';else rampLegend">
  <li *ngFor="let elem of legend">
    <img src="{{ elem.icon }}" >
    <span>{{ elem.label }}</span>
  </li>
</ul>
<ng-template #rampLegend>
  <div class="rampWrapper">
    <span>{{ domain.min }}</span>
    <ul>
      <li *ngFor="let elem of legend">
        <img src="{{ elem.icon }}">
      </li>
    </ul>
    <span>{{ domain.max }}</span>
  </div>
</ng-template>
